import React from 'react';
import BDLogo from '../../static/img/bd-logo-white-footer.png';

const Footer = props => {
  return (
    <footer>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3">
            <a className="logo" href="http://www.bd.com/en-us">
              <img src={BDLogo} alt="BD" />
            </a>
            <div className="social">
              <a href="https://www.facebook.com/BectonDickinsonandCo?ref=bookmarks">
                <i className="fa fa-facebook" aria-hidden="true"></i>
              </a>
              <a href="https://twitter.com/BDandCo">
                <i className="fa fa-twitter" aria-hidden="true"></i>
              </a>
              <a href="https://www.linkedin.com/company/bd1?trk=biz-companies-cym">
                <i className="fa fa-linkedin" aria-hidden="true"></i>
              </a>
              <a href="https://www.youtube.com/channel/UCPGmutY43EjP_3ijOugNGnA">
                <i className="fa fa-youtube" aria-hidden="true"></i>
              </a>
            </div>
          </div>
          <div className="col-md-6">
            <p className="copyright">
              &copy; 2024 BD. All rights reserved. Unless otherwise noted, BD,
              the BD Logo and all other trademarks are property of Becton,
              Dickinson and Company.
            </p>
          </div>
          <div className="col-md-3">
            <div className="links">
              <a href="http://www.bd.com/en-us/privacy-policy">Privacy</a>
              <span className="pipe">|</span>
              <a href="http://www.bd.com/en-us/terms-of-use">
                Terms &amp; Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
